import React from "react";
import ExportPanel from "../ExportPanel";

// Same panel as the project-wide export, in "selection" scope: the payload
// carries the ticked site-visit ids and the file list is the per-user folder.
const ExportSelectedTable = ({
  visible,
  open,
  onCancel,
  selectedSiteVisitIds = [],
}) => (
  <ExportPanel
    open={visible ?? open ?? false}
    onClose={onCancel}
    scope="user"
    selectedSiteVisitIds={selectedSiteVisitIds}
  />
);

export default ExportSelectedTable;
